import { render, staticRenderFns } from "./BronchopneumoniaScoreAnalysisTable.vue?vue&type=template&id=755fe55c&scoped=true&"
import script from "./BronchopneumoniaScoreAnalysisTable.vue?vue&type=script&lang=ts&"
export * from "./BronchopneumoniaScoreAnalysisTable.vue?vue&type=script&lang=ts&"
import style0 from "./BronchopneumoniaScoreAnalysisTable.vue?vue&type=style&index=0&id=755fe55c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755fe55c",
  null
  
)

export default component.exports